/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemAssignee_EmbedNode = {
    readonly chatActivityCount?: number | null | undefined;
    readonly email?: string | null | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemNode_EmbedNode" | "TypographyNodeName_EmbedNode">;
    readonly " $refType": "ListItemAssignee_EmbedNode";
};
export type ListItemAssignee_EmbedNode$data = ListItemAssignee_EmbedNode;
export type ListItemAssignee_EmbedNode$key = {
    readonly " $data"?: ListItemAssignee_EmbedNode$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemAssignee_EmbedNode">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "TypographyNodeName_EmbedNode"
},
v1 = {
  "condition": "includeChatActivityCount",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filterChatActivityCount"
        }
      ],
      "kind": "ScalarField",
      "name": "chatActivityCount",
      "storageKey": null
    }
  ]
},
v2 = [
  (v0/*: any*/),
  {
    "condition": "includeEmail",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ]
  },
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filterChatActivityCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAvatar"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeChatActivityCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeEmail"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemAssignee_EmbedNode",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeAvatar",
          "variableName": "includeAvatar"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ListItemNode_EmbedNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "type": "Group",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "User",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v2/*: any*/),
      "type": "Provider",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();
(node as any).hash = 'b24565015abc35d55a2dfeea1f8a5246';
export default node;
